import React, { useEffect, useState } from 'react';

import { Button, Theme, Box, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import { Trash, Upload } from 'react-feather';

import { Spinner } from 'src/components/Spinners/followTheLead/spinner';
import FilesDropzone from 'src/components/CutsomFilesDropzone';
import { IMAGES_TYPE } from 'src/constants/dropzone/medias';
import { REMOVE } from 'src/constants/events/files';
import { NoImages } from './NoImages';
import { Images } from './Images';

import { IModalEvidences } from './types';

import { useTranslation } from 'react-i18next';
import useLead from 'src/hooks/useLead';

const useStyles = makeStyles((theme: Theme) => ({
    card: {
        overflow: 'scroll',
        position: 'relative',
    },
    margin: {
        marginBottom: '1em',
    },
    button: {
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
    spinner: { position: 'absolute', top: 100, right: 50 },
    delete: {
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
        color: 'white',
        backgroundColor: theme.palette.error.main,
        '&:hover': {
            backgroundColor: theme.palette.error.dark,
        },
    },
}));

export const ModalEvidences = ({
    leadId,
    loading,
    medias = [],
}: IModalEvidences) => {
    const { updateFiles } = useLead();
    const { t } = useTranslation();
    const classes = useStyles();

    const [currentImage, setCurrentImage] = useState<number>(0);
    const [files, setFiles] = useState(null);

    useEffect(() => {
        if (files) updateFiles({ files, leadId: leadId });
    }, [files]);

    const handleAddImage = (files: any) => setFiles(files);

    const handleDelete = (index: number) => {
        updateFiles({ leadId: leadId, event: REMOVE, index });
        setCurrentImage(0);
    };

    return (
        <Grid container spacing={2}>
            {loading && (
                <Box className={classes.spinner}>
                    <Spinner size={12} />
                </Box>
            )}

            <Grid item xs={12}>
                {medias.length > 0 ? (
                    <Images
                        medias={medias}
                        currentImage={currentImage}
                        setCurrentImage={setCurrentImage}
                    />
                ) : (
                    <NoImages />
                )}
            </Grid>

            <Grid item xs={12}>
                <Grid container spacing={2} justifyContent="flex-end">
                    {medias.length > 0 && (
                        <Grid item xs={12} sm={'auto'}>
                            <Button
                                disabled={loading}
                                startIcon={<Trash />}
                                variant="contained"
                                className={classes.delete}
                                onClick={() => handleDelete(currentImage)}
                            >
                                {t('Placeholder.DeleteEvidence')}
                            </Button>
                        </Grid>
                    )}

                    <Grid item xs={12} sm={'auto'}>
                        <FilesDropzone
                            style={{ width: '100%' }}
                            types={IMAGES_TYPE}
                            customFunction={handleAddImage}
                            multiple={'true'}
                            content={
                                <Button
                                    disabled={loading}
                                    startIcon={<Upload />}
                                    variant="contained"
                                    color="primary"
                                    className={classes.button}
                                >
                                    {t('Buttons.LoadImages')}
                                </Button>
                            }
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
